import React from 'react';
import STAIImg from '@/components/STAIImg';
import { STAI_CONTEXT } from '@/constants/context';

const STAI = () => {
  return (
    <div
      id='content-STAI'
      className='w-full h-full flex flex-col justify-center items-center gap-4 md:gap-14'
    >
      <section className='w-full flex justify-center items-center'>
        <STAIImg />
      </section>
      <section className='w-full h-fit flex flex-col gap-4 md:gap-6'>
        {/* Mobile: Stacked layout */}
        <div className='flex flex-col xl:hidden gap-2 md:gap-6'>
          <strong className='text-[20px] font-bold text-white md:text-[32px]'>
            {STAI_CONTEXT.TITLE}
          </strong>
          <div className='w-full flex flex-row md:gap-4 gap-2'>
            <div className='w-2 bg-[#FCCB16]'></div>
            <div className='text-[14px] font-semibold text-white md:text-[20px]'>
              <p>Our AI technology for the real-time solution</p>
              <p>of spatiotemporal problems of space assets in timeline.</p>
            </div>
          </div>
        </div>

        {/* Desktop: Horizontal layout */}
        <div className='hidden xl:flex flex-row items-center gap-10'>
          <strong className='text-4xl font-bold text-white whitespace-nowrap'>
            {STAI_CONTEXT.TITLE}
          </strong>
          <div className='w-1 h-8 bg-[#FCCB16]'></div>
          <div className='text-xl font-semibold text-white'>
            Our AI technology for the real-time solution
            <br />
            of spatiotemporal problems of space assets in timeline.
          </div>
        </div>

        <article className='text-[14px] md:text-[18px] font-medium text-white md:text-justify'>
          {STAI_CONTEXT.DESCRIPTION}
        </article>
      </section>
    </div>
  );
};

export default React.memo(STAI);
